import axios from 'axios';

export const urlToBase64 = async (url, config = {}) => {
  if (!/^http/.test(url) && !/^\//.test(url)) {
    return url;
  }
  const version = /\?/.test(url) ? `&v=${new Date().getTime()}` : `?v=${new Date().getTime()}`;
  const response = await axios.get(`${url}${version}`, { ...config, responseType: 'arraybuffer' });
  const type = response.headers['content-type'];
  return `data:${type};base64,${window.btoa(new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), ''))}`;
};

export const urlToBlob = async (url, config = {}) => {
  if (!/^http/.test(url) && !/^\//.test(url)) {
    return url;
  }
  const version = /\?/.test(url) ? `&v=${new Date().getTime()}` : `?v=${new Date().getTime()}`;
  const response = await axios.get(`${url}${version}`, { ...config, responseType: 'blob' });
  return response.data;
};

export function fileToBase64(file) {
  const fileReader = new FileReader();
  return new Promise((reslove, reject) => {
    fileReader.readAsDataURL(file);
    fileReader.onload = (event) => {
      reslove(event.target.result);
    };
    fileReader.onerror = reject;
  });
}

export function base64ToFile(dataURL, fileName, mimeType = null) {
  const arr = dataURL.split(',');
  const defaultMimeType = arr[0].match(/:(.*?);/)[1];
  const suffix = defaultMimeType.split('/')[1];
  const fileName0 = `${new Date().getTime()}.${suffix}`;
  const bStr = window.atob(arr[1]);
  let n = bStr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bStr.charCodeAt(n);
  }
  return new File([u8arr], fileName || fileName0, { type: mimeType || defaultMimeType });
}

export function base64ToBlob(base64, fileType) {
  // 第二种：直接传入base64文件
  const audioSrc = base64; // 拼接最终的base64

  const arr = audioSrc.split(',');
  const array = arr[0].match(/:(.*?);/);
  const mime = (array && array.length > 1 ? array[1] : fileType) || fileType;
  // 去掉url的头，并转化为byte
  const bytes = window.atob(arr[1]);
  // 处理异常,将ascii码小于0的转换为大于0
  const ab = new ArrayBuffer(bytes.length);
  // 生成视图（直接针对内存）：8位无符号整数，长度1个字节
  const ia = new Uint8Array(ab);
  for (let i = 0; i < bytes.length; i++) {
    ia[i] = bytes.charCodeAt(i);
  }
  return new Blob([ab], {
    type: mime,
  });
}

export function base64ToBuffer(base64) {
  const text = new TextEncoder();
  return text.encode(btoa(base64));
}

export function blobToBase64(blob) {
  const a = new FileReader();
  return new Promise((resolve, reject) => {
    a.readAsDataURL(blob);
    a.onload = function b(e) {
      resolve(e.target.result);
    };
    a.onerror = reject;
  });
}

export async function urlToFile(url) {
  const base64 = await urlToBase64(url);
  return base64ToFile(base64);
}

// export async function urlToBlob(url) {
//   const base64 = await urlToBase64(url);
//   return base64ToBlob(base64);
// }

export default { base64ToFile, base64ToBlob, base64ToBuffer, fileToBase64, urlToBase64, urlToFile, urlToBlob };
